import React, { useEffect, useState } from "react";
import { FcNext, FcPrevious } from "react-icons/fc";
import { Oval } from "react-loading-icons";

import styled from "styled-components";
import { GetThaiZoneDate, XButton } from "./Helper";

export const getMonthLastDate = (year, month) => {
  let m = month;
  let y = year;
  if (m === 12) {
    m = 1;
    y = y + 1;
  }

  return GetThaiZoneDate(new Date(y, m, 0));
};

export const getDatesRange = (year, month) => {
  return [getMonthFirstDate(year, month), getMonthLastDate(year, month)];
};

export const getMonthFirstDate = (year, month) => {
  return GetThaiZoneDate(new Date(year, month - 1, 1));
};

export const DefaultCalendarDate = () => {
  let date = new Date();
  let month = date.getMonth();
  let year = date.getFullYear();
  return { date, month, year };
};

export default function MyCalendar(props) {
  const [curDate, setCurDate] = useState({}); //  props.curDate; // useState({});
  const [calendar, setCalendar] = useState([]);
  const [events, setEvents] = props.events;
  const [loading, setLoading] = props.loading;

  const { onDayClick, onCalendarChanged } = props;

  useEffect(() => {
    setCurDate(DefaultCalendarDate());

    return () => {
      setCalendar([]);
      setCurDate({});
    };
  }, []);

  useEffect(() => {
    if (curDate != null) {
      onCalendarChanged(curDate);
    }
  }, [curDate]);

  useEffect(() => {
    getCalendar();
  }, [events]);
  //
  const getDayBox = (iDay, className, events) => {
    let x = getEventData(iDay, events);
    // console.log("the x ==> ", x);
    return { da: iDay, className: className, text: getEventData(iDay, events) };
  };

  const getCalendar = () => {
    // first day of the month
    const start = new Date(curDate.year, curDate.month, 1).getDay();
    // last date of the month
    const endDate = new Date(curDate.year, curDate.month + 1, 0).getDate();
    // last day of the month
    const end = new Date(curDate.year, curDate.month, endDate).getDay();
    // last date of the previous month
    const endDatePrev = new Date(curDate.year, curDate.month, 0).getDate();

    let arrDays = [];

    // add previous
    for (let i = start; i > 0; i--) {
      arrDays.push(getDayBox(endDatePrev - i + 1, "inactive"));
    }

    // add day of current month
    for (let i = 1; i <= endDate; i++) {
      let isToday =
        i === curDate.date.getDate() &&
        curDate.month === new Date().getMonth() &&
        curDate.year === new Date().getFullYear();
      arrDays.push(getDayBox(i, isToday ? "today" : null));
    }

    // add next first group of month
    for (let i = end; i < 6; i++) {
      arrDays.push(getDayBox(i - end + 1, "inactive"));
    }
    setCalendar(arrDays);
  };

  const navClick = (actionType) => {
    let year = curDate.year;
    let month = curDate.month;
    let date = curDate.date;
    if (actionType === "prev" && month === 0) {
      year--;
      month = 11;
    } else if (actionType === "next" && month === 11) {
      year++;
      month = 0;
    } else {
      month = actionType === "next" ? month + 1 : month - 1;
    }
    date = new Date(year, month, new Date().getDate());
    month = date.getMonth();
    year = date.getFullYear();
    setCurDate({
      date,
      month,
      year,
    });
  };

  const getEventData = (day, event) => {
    let r = events?.filter((r) => r.event_date.day === day);

    // console.log("R list", r);
    return r?.length > 0 ? (
      <div>
        {r.map((item) => {
          return <div>{item.event_text}</div>;
        })}
      </div>
    ) : (
      <></>
    );
  };

  // แสดงข้อมูลแต่ละวันไปที Calendar
  const showText = (item) => {
    return (
      <DivEventsWrapper>
        <DivEventHeader>{item.da}</DivEventHeader>
        {item.className !== "inactive" ? (
          loading ? (
            <DivEventBodyLoading>
              <Oval
                width={150}
                height={150}
                speed={0.5}
                string={"wait"}
                stroke="var(--bg-primary)"
              />
            </DivEventBodyLoading>
          ) : (
            <DivEventBody>{item.text}</DivEventBody>
          )
        ) : (
          <></>
        )}
      </DivEventsWrapper>
    );
  };

  return (
    <MainContainer>
      <HeaderWrapper>
        <ButtonWrapper>
          <DivButton onClick={() => navClick("prev")}>
            <FcPrevious size={25} />
          </DivButton>
        </ButtonWrapper>

        <MonthText>{`${thaiMonths[curDate.month]}  ${
          curDate.year + 543
        }`}</MonthText>

        <ButtonWrapper>
          <XButton
            onClick={() => {
              setCurDate(DefaultCalendarDate());
            }}
          >
            {loading ? (
              <Oval height={20} style={{ marginInlineStart: "3px" }} />
            ) : (
              "เดือนปัจจุบัน"
            )}
          </XButton>
          <DivButton onClick={() => navClick("next")}>
            <FcNext size={25} />
          </DivButton>
        </ButtonWrapper>
      </HeaderWrapper>
      <Wraper>
        {daysWeek.map((item, i) => {
          return <CaleDivHeader>{`${item}.`}</CaleDivHeader>;
        })}
      </Wraper>
      <Wraper>
        {calendar.map((item, i) => {
          if (item.className === "inactive")
            return <DivDayInActive>{showText(item)}</DivDayInActive>;
          else if (item.className === "today")
            return (
              <DivToday onClick={() => onDayClick && onDayClick(item, curDate)}>
                {showText(item)}
              </DivToday>
            );
          else
            return (
              <DivDay onClick={() => onDayClick && onDayClick(item, curDate)}>
                {showText(item)}
              </DivDay>
            );
        })}
      </Wraper>
    </MainContainer>
  );
}

export const DefaultCalendarEvent = [
  {
    event_date: { day: 15, month: 3, year: 2025 },
    event_text: (
      <>
        <div>เช้า</div>
        <div>บ่าย</div>
        <div>ดึก</div>
      </>
    ),
  },
];

const MainContainer = styled.div`
  padding: 10px;
`;

const Wraper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
`;

const MonthText = styled.div`
  display: flex;
  padding: 10px;
  font-size: 20px;
  color: var(--btn-forecolor);
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  margin: 2px;
`;

const CaleDivHeader = styled.div`
  display: flex;
  justify-content: center;
  color: var(--fore-primary);
  margin: 5px;
  background-color: var(--btn-backcolor);
  border-radius: 10px;
  padding-block: 5px;
  margin-top: 10px;
`;

const DivDay = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px;
  background: var(--bg-secondary);
  /* border: 3px solid ; */
  margin: 2px;
  min-height: 50px;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    margin: 1px;
    border: 1px solid var(--tb-bg-hover);
  }
`;

const DivToday = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px;
  border: 3px solid var(--bg-secondary);
  color: #f51109;
  margin: 2px;
  min-height: 50px;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    margin: 1px;
    border: 1px solid var(--tb-bg-hover);
  }
`;

const DivDayInActive = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px;
  background-color: var(--bg-primary);
  margin: 5px;
  min-height: 50px;
  border-radius: 5px;
`;

const DivButton = styled.div`
  /* cursor: pointer; */
  min-width: 50px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-inline: 2px;
  padding-inline: 10px;
  cursor: pointer;
  border: 1px solid var(--border-color);

  &:hover {
    background-color: var(--bg-secondary);
  }
`;

const DivEventsWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 300px;
  flex-direction: column;
  font-size: 13px;
  font-family: tahoma;
`;
const DivEventBody = styled.div`
  padding: 5px;
`;
const DivEventBodyLoading = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;
const DivEventHeader = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
  justify-content: end;
`;

export const engMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฏาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export const TheMonths = [
  { id: 1, name: "มกราคม", short: "ม.ค.", eng: "January" },
  { id: 2, name: "กุมภาพันธ์", short: "ก.พ.", eng: "February" },
  { id: 3, name: "มีนาคม", short: "มี.ค.", eng: "March" },
  { id: 4, name: "เมษายน", short: "เม.ย.", eng: "April" },
  { id: 5, name: "พฤษภาคม", short: "พ.ค.", eng: "May" },
  { id: 6, name: "มิถุนายน", short: "มิ.ย.", eng: "June" },
  { id: 7, name: "กรกฏาคม", short: "ก.ค.", eng: "July" },
  { id: 8, name: "สิงหาคม", short: "ส.ค.", eng: "August" },
  { id: 9, name: "กันยายน", short: "ก.ย.", eng: "September" },
  { id: 10, name: "ตุลาคม", short: "ต.ค.", eng: "October" },
  { id: 11, name: "พฤศจิกายน", short: "พ.ย.", eng: "November" },
  { id: 12, name: "ธันวาคม", short: "ธ.ค.", eng: "December" },
];

export const thaiMonthsShort = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
export const daysWeek = ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"];
